import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import Spinner from "../Spinner";
import approvedImage from "../../assets/img/approved.svg"

import LmsService from "../../services/LmsService";
import DamService from '../../services/DamService';
import shuffle from "../../utils/shuffleArray";
import { ordenationLetter } from "../../utils/ordenation";
import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM';
import { formattedCurrentDate } from '../../utils/dateFormat';
import { useAuth } from '../../hooks/Auth';
import "./styles.css";
import Config from "../../config/config";

export default function ProofEvaluative({ proof_id, item_type, item_id, item_title, setCourseFinish}) {

  const [proof, setProof] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showProof, setShowProof] = useState(false);
  const [finishProof, setFinishProof] = useState(false);
  const [approved, setApproved] = useState(false);
  const [userLastTry, setUserLastTry] = useState({
    approved: false,
    attempt: 0,
  });
  const [userAnswers, setUserAnswers] = useState([]);
  const [grade, setGrade] = useState(0);
  const [uriCertificate, setUriCertificate] = useState();
  const [trailCategory, setTrailCategory] = useState();
  const [courseCategory, setCourseCategory] = useState();

  const lmsService = new LmsService();
  const damService = new DamService();

  const { user } = useAuth();

  const shuffleAnswers = () => {
    setProof({
      ...proof,
      questions: proof.questions.map(item => {
        //Alterar ordem das alternativas
        item.answers = shuffle(item.answers);

        // Adiciona listagem nas alternativas
        item.answers = ordenationLetter(item.answers);
        return item;
      })
    }
    );
  }

  useEffect(() => {
    if (showProof) {
      shuffleAnswers();
    }
  }, [showProof])

  useEffect(() => {
    async function getProofData() {
      try {
        setLoading(true);

        const [proofResponse, userProofResponse] = await Promise.all([
          lmsService.getProof(proof_id),
          lmsService.userProofsCollection({
            proof_id,
            course_id: item_type === "course" ? item_id : null,
            trail_id: item_type === "trail" ? item_id : null,
          }),
        ]);

        const lastTry = userProofResponse.data.userProofs_collection.userproofs.slice(-1)[0];

        if (lastTry) {
          setUserLastTry(lastTry);
        }

        setProof(proofResponse.data.proof);
      } catch (e) {
        toast.error("Ocorreu um erro ao buscar a avaliação!");
        // Google Tag Manager
        addToDataLayerGTM({
          'event' : 'erro',
          'etapa' : 'erro ao buscar avaliação'
        });
      } finally {
        setLoading(false)
      }
    }

    getProofData();

    /**
     * Busca a categoria da trilha ou course para preencher o campo 'produto'
     * do evento 'solicitacao_servico' do GTM
     */
    if(item_type === "trail") {
      window.customData.curso.etapa = 'avaliacao-de-aprendizagem';
      lmsService.getCategoryHasTrail(item_id)
      .then(response => {
        const categoryHasTaril = response.data.categoryHasTrail_collection.category_has_trail;

        if(categoryHasTaril.length > 0) {
          damService.getGategory(categoryHasTaril[0].category_id)
          .then(response => setTrailCategory(response.data.category));
        }

      });
    } else {
      window.customData.curso.indice = 2;
      window.customData.curso.etapa = 'avaliacao-de-aprendizagem';
      lmsService.getCategoryHasCourse(item_id)
      .then(response => {
        const categoryHasCourse = response.data.categoryHasCourse_collection.category_has_course;

        if(categoryHasCourse.length > 0) {
          damService.getGategory(categoryHasCourse[0].category_id)
          .then(response => setCourseCategory(response.data.category));
        }

      });
    }

  }, []);

  useEffect(() => {
    async function loadUserCompletedJourney() {
      if (userLastTry.approved || approved) {

        if (item_type === "course") {
          const response = await lmsService.courseHasUserItem(item_id);
          //Se tiver registro em course_has_user, gera a URL no certificado.
          //Caso contrário, insere o registro em course_has_user.
          if (response.data.course_has_user_item) {
            setUriCertificate("/api/v1/lms/certified_generate?u=" + response.data.course_has_user_item.id);
            setCourseFinish(response.data.course_has_user_item.id);
          } else {
            await saveFinishCourse();
          }
        }

        if (item_type === "trail") {
          const response = await lmsService.trailHasUserItem(item_id);

          //Se tiver registro em trail_has_user, gera a URL no certificado.
          //Caso contrário, insere o registro em trail_has_user.
          if (response.data.trail_has_user_item) {
            setUriCertificate("/api/v1/lms/certified_trail_generat?u=" + response.data.trail_has_user_item.id);
            setCourseFinish(response.data.trail_has_user_item.id);
          } else {

            await saveFinishTrail();
          }
        }
      }
    }

    loadUserCompletedJourney();
  }, [approved, userLastTry.approved]);

  const handleTryAgain = () => {
    setShowProof(false);
    setFinishProof(false);
    setUserAnswers([]);
    setApproved(false);
    setGrade(0);
  }

  const handleSaveAnswers = anwser => {
    let anwserFound = userAnswers.filter(item => {
      return +item.question_id === +anwser.question_id;
    });

    if (anwserFound.length) {
      setUserAnswers(userAnswers.map(item => {
        if (+item.question_id === +anwser.question_id) {
          item.isCorrect = anwser.isCorrect;
        }
        return item;
      }));
      return;
    }

    setUserAnswers([...userAnswers, anwser])
  }

  const saveFinishCourse = async (hasGTMEvents) => {
    // Google Tag Manager
    const dataLayer = {
      event : 'solicitacao_servico',
      nome_servico : 'finalizar-curso',
      id_solicitacao : user.id,
      nome_curso : item_title,
      data_servico : formattedCurrentDate(),
      produto : courseCategory ? courseCategory.title : '',
      brand : 'porto seguro',
      retorno : '',
      descricao : 'etapa desbloqueada'
    }

    try {
      const response = await lmsService.finishProof({ course_id: item_id, status: "finalized" });
      setCourseFinish(response.data.updateCourseHasUser.id);
      setUriCertificate("/api/v1/lms/certified_generate?u=" + response.data.updateCourseHasUser.id);
      dataLayer.retorno = 'sucesso';
    } catch (e) {
      toast.error("Não foi possível salvar o resultado da prova!");
      // Google Tag Manager
      addToDataLayerGTM({
        'event' : 'erro',
        'etapa' : 'erro ao salvar resultado da prova'
      });
      dataLayer.retorno = 'erro';
    }

    hasGTMEvents && addToDataLayerGTM(dataLayer);
  }

  const saveFinishTrail = async (hasGTMEvents) => {
    // Google Tag Manager
    const dataLayer = {
      event : 'solicitacao_servico',
      nome_servico : 'finalizar-trilha',
      id_solicitacao : user.id,
      nome_curso : item_title,
      data_servico : formattedCurrentDate(),
      produto : trailCategory ? trailCategory.title : '',
      brand : 'porto seguro',
      retorno : '',
      descricao : 'etapa desbloqueada'
    }

    try {
      const result = await lmsService.finishTrail({ trail_id: item_id, status: "finalized" });
      setCourseFinish(result.data.updateTrailHasUser.id);
      setUriCertificate("/api/v1/lms/certified_trail_generat?u=" + result.data.updateTrailHasUser.id);
      dataLayer.retorno = 'sucesso';
    } catch (e) {
      toast.error("Não foi possível salvar o resultado da prova!");
      // Google Tag Manager
      addToDataLayerGTM({
        'event' : 'erro',
        'etapa' : 'erro ao salvar resultado da prova'
      });

      dataLayer.retorno = 'erro';
    }

    hasGTMEvents && addToDataLayerGTM(dataLayer);
  }

  const saveAnswers = async (userProofId) => {

    // Google Tag Manager
      const date = new Date();
      const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

       const dataLayer ={
        event : 'solicitacao_servico',
        nome_servico : 'avaliacao:aprendizagem',
        id_solicitacao : user.id || '',
        nome_curso :  item_title || '',
        data_servico : formattedDate,
        produto : courseCategory ? courseCategory.title : '',
        brand : 'porto seguro',
        retorno : '',
        descricao : ''
       }

    try {
      userAnswers.map(async answser => {
        await lmsService.saveAnwserQuestion(
          {
            question_id: answser.question_id,
            answer_id: answser.answer_id,
            item_id: item_id,
            item_type: item_type,
            user_proof: userProofId,
          }
        )
      });
      dataLayer.retorno = 'sucesso';
      dataLayer.descricao = 'sucesso ao realizar avaliacao';
    } catch (e) {
      dataLayer.retorno = 'erro';
      dataLayer.descricao = 'erro ao realizar avaliacao';
      toast.error("Não foi possível salvar o resultado da prova!");
    }
    item_type === 'course' && addToDataLayerGTM(dataLayer);
  }

  const handleSubmit = async () => {
    // Verificar se todas as questões foram marcadas
    let numQuestions = proof.questions.length;
    let numAnwser = userAnswers.length;

    if (numQuestions !== numAnwser) {
      toast.error("Responda todas as perguntas!");
      return;
    }

    window.scroll(0, 0);

    // Verificar quantidade de acertos
    let questionsCorrect = userAnswers.filter(item => {
      return item.isCorrect
    });

    const grade = questionsCorrect.length;

    setFinishProof(true);
    setShowProof(false);
    setGrade(grade);
    setUserLastTry({
      ...userLastTry,
      attempt: userLastTry.attempt + 1,
    });

    let localApproved;

    if (!!proof.minimum && grade < proof.minimum) {
      localApproved = false;
      setApproved(false);
    } else {
      localApproved = true;
      setApproved(true);
    }

    setLoading(true);

    const response = await lmsService.createUserProof({
      proof_id,
      course_id: item_type === "course" ? item_id : null,
      trail_id: item_type === "trail" ? item_id : null,
      approved: localApproved,
      grade,
      total_question: proof.questions.length,
    });

    const userProofId = response.data.createUserProof.id;

    await saveAnswers(userProofId);

    if (localApproved === false) {
      setLoading(false);
      return;
    }

    // Se for curso, seta como finalizado em couse_has_user para emissão do certificado.
    if (item_type === "course") {
      await saveFinishCourse(true); // O true como parâmetro indica que é para disparar o evento do GTM
    }

    // Se for trilha, seta como finalizado em trail_has_user para emissão do certificado.
    if (item_type === "trail") {
      await saveFinishTrail(true); // O true como parâmetro indica que é para disparar o evento do GTM
    }

    setLoading(false);
  }

  function handleCheckURL(url){

    // Google Tag Manager
    const date = new Date();
    const formattedDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`

    const dataLayer ={
      event : 'solicitacao_servico',
      nome_servico : 'gerar_certificado:curso',
      nome_curso :  item_title || '',
      data_servico : formattedDate,
      produto : item_title || '',
      brand : 'porto seguro',
      retorno : url ? 'sucesso' : 'erro',
      descricao : url ? 'certificado gerado' : 'erro ao gerar certificado',
      }

    addToDataLayerGTM(dataLayer);
    window.customData.curso.indice = window.customData.curso.modulos;
    window.customData.curso.etapa = "emissao-de-certificado";
  }
  window.customData.curso.etapa = 'avaliacao-de-aprendizagem';
  return (
    <div className="proofContainer">

      <h1>Avaliação de aprendizagem</h1>

      {loading ? (
        <div className="loadingContainer">
          <Spinner />
        </div>
      ) : (
          <div className='proofContent'>

            {proof.attempts !== userLastTry.attempt && !userLastTry.approved && !showProof && !finishProof && (
              <div className="orientationProof">
                <h1>Antes de iniciar sua avaliação, fique atento:</h1>
                {proof.attempts && (
                  <h2>Você terá <span
                    className="boldNumber">{proof.attempts - userLastTry.attempt}</span> tentativa{proof.attempts - userLastTry.attempt === 1 ? '' : 's'} para
                  a realização da prova;</h2>
                )}
                <h3>
                  Para ser aprovado é necessário acertar <span
                    className="boldNumber">{proof.minimum ? proof.minimum : 0}</span> de
                <span className="boldNumber"> {proof.questions.length}</span> questões.
              </h3>
              <button data-gtm-type="click" data-gtm-clicktype="button" data-gtm-name="iniciar avaliação"
                className="buttonProof buttonProofSuccess"
                onClick={() => setShowProof(true)}
              >
                Iniciar avaliação
              </button>
              </div>
            )}

            {(userLastTry.approved || approved) && (
              <div className="approved">
                <h1>Resultado da sua avaliação:</h1>
                <img src={approvedImage} alt="Aprovado" />
                <h2>
                Parabéns! Você foi aprovado(a).
                <br />
                Para concluir o curso, emita o certificado abaixo!
              </h2>
              <a data-gtm-type="click" data-gtm-clicktype="button" data-gtm-name="emitir certificado"
                className="buttonProof buttonProofPrimary"
                target={"_blank"}
                rel="noopener noreferrer"
                href={Config.baseUrl + uriCertificate}
                onClick={() => handleCheckURL(Config.baseUrl + uriCertificate)}
              >
                Emitir certificado
              </a>
              </div>
            )}

            {proof.attempts && proof.attempts > userLastTry.attempt && !approved && finishProof && (
              <div className="disapproved">
                <h1>Resultado da sua avaliação:</h1>
                <h2>Não foi dessa vez!</h2>
                <h3>
                  Você acertou somente <span className="boldNumberRed">{grade}</span> de
                <span className="boldNumber"> {proof.questions.length}</span> questões e não atingiu o número mínimo de
                <span className="boldNumber"> {proof.minimum}</span> acertos.
                <br />
                Você ainda possui <span
                    className="boldNumber">{proof.attempts - userLastTry.attempt}</span> tentativa{proof.attempts - userLastTry.attempt === 1 ? '' : 's'}.
              </h3>
              <button data-gtm-type="click" data-gtm-clicktype="button" data-gtm-name="fazer nova tentativa"
                className="buttonProof buttonProofPrimary"
                onClick={handleTryAgain}
              >
                Fazer nova tentativa
              </button>
              </div>
            )}

            {proof.attempts && proof.attempts === userLastTry.attempt && !userLastTry.approved && (
              <div className="disapproved">
                <h1>Resultado da sua avaliação:</h1>
                <h2>Não foi dessa vez!</h2>
                <h3>
                  Você acertou somente <span className="boldNumberRed">{userLastTry.grade}</span> de
                <span className="boldNumber"> {proof.questions.length}</span> questões e não atingiu o número mínimo de
                <span className="boldNumber"> {proof.minimum}</span> acertos.
                <br />
                  <br />
                  <strong>Você atingiu o número máximo de tentativas.</strong>
                </h3>
              </div>
            )}

            {!proof.attempts && !approved && finishProof && (
              <div className="disapproved">
                <h1>Resultado da sua avaliação:</h1>
                <h2>Não foi dessa vez!</h2>
                <h3>
                  Você acertou somente <span className="boldNumberRed">{grade}</span> de
                <span className="boldNumber"> {proof.questions.length}</span> questões e não atingiu o número mínimo de
                <span className="boldNumber"> {proof.minimum}</span> acertos.
              </h3>
              <button data-gtm-type="click" data-gtm-clicktype="button" data-gtm-name="fazer nova tentativa"
                className="buttonProof buttonProofPrimary" onClick={handleTryAgain}>
                Fazer nova tentativa
              </button>
              </div>
            )}

            {showProof && proof.questions && proof.questions.map((question) => (
              <div className="proof_question" key={question.id}>
                <div className={"question"}>{question.title}</div>
                {
                  question.answers.map((answer) => (
                    <label
                      onClick={() => handleSaveAnswers({
                        question_id: question.id,
                        isCorrect: answer.is_correct,
                        answer_id: answer.id
                      })}
                      htmlFor={answer.id}
                      className="proofAnswer"
                      key={answer.id}
                    >

                    <input id={answer.id} className="answerRadio" data-gtm-form="input" data-gtm-name={question.id} type="radio" name={question.id} value={answer.id}/>

                      <div className="answerContent">
                        <div className={"inputStyle"} />
                        {answer.orderList} {answer.title}
                      </div>

                    </label>
                  ))
                }
              </div>
            ))}

          {showProof && (
            <button data-gtm-type="click" data-gtm-clicktype="button" data-gtm-name="entregar avaliação"
              className="buttonProof buttonProofPrimary" onClick={handleSubmit}>
              Entregar Avaliação
            </button>
          )}

          </div>
        )}

    </div>
  );
}




// WEBPACK FOOTER //
// ./src/components/Proof/ProofEvaluative.jsx